import { Box } from '@mui/material'
import patternRight from '../../../common/images/gridPatternRight.png'
import patternLeft from '../../../common/images/gridPatternLeft.png'
import React from 'react'

export default function CreatePageWrapper({ children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 16px',
        backgroundColor: '#F5F5F5',
        height: '100vh',
        width: '100%',
        position: 'relative'
      }}
    >
      <Box
        component='img'
        alt='pattern'
        src={patternRight}
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '200px',
          height: 'auto'
        }}
      />
      <Box
        component='img'
        alt='pattern'
        src={patternLeft}
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '200px',
          height: 'auto'
        }}
      />
      {children}
    </Box>
  )
}
